// Image
// - Marketing
import barChartIcon from "../../images/bar-chart-icon.svg";
import privyLogo from "../../images/privy-logo.jpg";
import optinMonsterLogo from "../../images/optin-monster-logo.jpg";
import recartLogo from "../../images/recart-logo.jpg";
import luckyOrangeIcon from "../../images/lucky-orange-icon.jpg";
import omnisendLogo from "../../images/omnisend-logo.png";
import referralCandy from "../../images/referral-candy-logo.png";
import socialShopWaveLogo from "../../images/social-shop-wave-logo.png";
import beeketingLogo from "../../images/beeketing-logo.png";
import boldCommerceLogo from "../../images/bold-commerce-logo.png";

// - Conversion
import targetIcon from "../../images/target-icon.svg";
import yuspifyLogo from "../../images/yuspify-logo.jpg";
import looxLogo from "../../images/loox-ico.jpg";
import giftWizardLogo from "../../images/gift-wizard-logo.png";

// - Design
import paletteIcon from "../../images/palette-icon.svg";
import pixcLogo from "../../images/pixc-logo.jpg";
import shogunPageBuilderLogo from "../../images/shogun-page-builder.jpg";
import shoptimizedLogo from "../../images/shoptimized-logo.jpg";
import wishpoondLogo from "../../images/wishpoond-logo.jpg";
import reConvertLogo from "../../images/re-convert-logo.png";
import outlaneLogo from "../../images/outlane-logo.png";

// - Shopify Experts
import shopifyExpertsIcon from "../../images/shopify-experts-icon.png";
import shopisionLogo from "../../images/shopision-logo.png";

// - Support
import plusIcon from "../../images/plus-icon.svg";
import rewindLogo from "../../images/rewind-logo.jpg";
import reamazeLogo from "../../images/reamaze-logo.jpg";

// - Orders and Shipping
import orderShipping from "../../images/orders-and-shipping.png";

// - Shopify and Woocomerce
import shopifyLogo from "../../images/shopify-logo-full.png";
import woocommerceLogo from "../../images/woocommerce-logo.png";

// - Design & Graphics
// import paletteIcon from "../../images/palette-icon.svg";
import vismeLogo from "../../images/Visme-logo.png";

export default {
  sections: {
    marketing: {
      header: {
        title: "Marketing Apps",
        subtitle:
          "Drive traffic to your store, capture emails and market better",
        img: barChartIcon
      },
      apps: [
        {
          storeLogo: [shopifyLogo],
          name: "Privy",
          title: "20% off for first 3 months",
          subtitle:
            "Email popups, exit intent, list growth, wheels & abandonment",
          img: privyLogo,
          link: "https://apps.shopify.com/privy",
          coupon: "SPOCKET20",
          headine: "Get 20% off a Privy Plus or Commerce Plan for 3 months",
          benefits: [
            {
              title: "Grow Your Email List",
              text:
                "Build beautiful popups with easy to use targeting & triggers that get people to join your list. Privy's customizable, mobile-friendly display types include popups, spin-to-win wheel, banners, flyouts, scroll boxes, announcement bars, and embedded forms."
            },
            {
              title: "Reduce Cart Abandonment",
              text:
                "Use targeted popups w/ exit intent & discounts to close the sale before people go away and automated recovery emails to bring them back. "
            },
            {
              title: "Offer Discounts and Coupons",
              text:
                "Create and distribute master and unique coupon codes that automatically sync with Shopify and Shopify Plus stores."
            }
          ]
        },
        {
          storeLogo: [shopifyLogo, woocommerceLogo],
          name: "OptinMonster",
          title: "20% off",
          subtitle:
            "Create beautiful lightbox email popups with exit intent & more",
          img: optinMonsterLogo,
          link: "https://apps.shopify.com/optinmonster",
          coupon: "SPOCKET20",
          headine:
            "Instantly boost leads and grow revenue with the most powerful conversion optimization toolkit in the world.",
          benefits: [
            {
              title: "",
              text:
                "Start with our 65+ high-converting templates for exit intent popups, welcome mats, floating announcement bars, slide-in scroll boxes, and more"
            },
            {
              title: "",
              text:
                "Show personalized messages with our powerful targeting features such as Exit Intent technology, InactivitySensor, time on site, specific products or pages, geographic location, onsite retargeting, referrer tracking, past campaign behavior and more."
            },
            {
              title: "",
              text:
                "Easily create unlimited A/B split tests to see which popup performs the best. Eliminate the guesswork and make data-driven decisions."
            }
          ]
        },
        {
          storeLogo: [shopifyLogo, woocommerceLogo],
          name: "Recart",
          title: "15% off",
          subtitle: "The #1 Facebook Messenger Marketing & Abandoned Cart App",
          img: recartLogo,
          link: "http://affiliate.ghostmonitor.com/affiliate?afmc=9i",
          headine: "The #1 Facebook Messenger Marketing & Abandoned Cart App",
          benefits: [
            {
              title: "Grow your Messenger audience",
              text: "Build your best Marketing list with Recart Messenger Tools"
            },
            {
              title: "Boost your revenue",
              text: "Generate More Sales with Automated Messenger Campaigns"
            }
          ]
        },
        {
          storeLogo: [shopifyLogo, woocommerceLogo],
          name: "Lucky Orange",
          title: "10% off",
          subtitle:
            "Let Lucky Orange help you understand why your website visitors aren’t converting",
          img: luckyOrangeIcon,
          link: "https://www.luckyorange.com/?promo=Chinese+New+Year",
          headine:
            "Let Lucky Orange help you understand why your website visitors aren’t converting",
          benefits: [
            {
              title: "",
              text:
                "Heatmaps, session recordings, form analytics, conversion funnels, live chat and polls provide insight into user experience challenges and technical issues that keep your customers from completing a sale."
            },
            {
              title: "",
              text: "Plans start at just $10 a month."
            }
          ]
        },
        {
          storeLogo: [shopifyLogo, woocommerceLogo],
          name: "Omnisend",
          title: "20% off for 2 months",
          subtitle: "Omnichannel Marketing Automation Built for Ecommerce",
          img: omnisendLogo,
          link: "https://www.omnisend.com/",
          coupon: "OMNISPOCKET",
          headine: "Omnichannel Marketing Automation Built for Ecommerce",
          benefits: [
            {
              title: "Complex Marketing Automation in One Easy-to-Use Platform",
              text:
                "Import several channels into the same complex automation workflow to create a seamless customer experience. No more bouncing around and coordinating channels across different websites, you can do it all from Omnisend."
            },
            {
              title: "Smart Segmentation for Ultra Precise Targeting",
              text:
                "Improve engagement, ROI, and customer loyalty by making sure each and every message you send is always relevant, all the time. Segment your subscribers via custom profile data, campaign engagement, and shopping behavior"
            },
            {
              title: "An Intuitive, User-Friendly Platform",
              text:
                "No matter what you need to create, Omnisend provides a friendly drag-and-drop editor for any message. No coding, no headaches, just perfect messages every time. "
            }
          ]
        },
        {
          storeLogo: [shopifyLogo],
          name: "ReferralCandy",
          title: "$50 off after trial",
          subtitle: "Get US$50 off after your 30-day free trial",
          img: referralCandy,
          link:
            "https://www.referralcandy.com/?promo=get-started-rc&utm_source=spocket&utm_medium=partnership&utm_campaisgn=spocket",
          headine: "Get US$50 off after your 30-day free trial",
          benefits: [
            {
              title: "",
              text:
                "ReferralCandy is a referral marketing tool that gets you more customers by incentivizing referrals. Think of it as word-of-mouth marketing on steroids."
            },
            {
              title: "",
              text:
                "More than 30,000 online stores have trusted ReferralCandy for their referral programs, generating more than $125M in referral sales."
            },
            {
              title: "",
              text:
                "With ReferralCandy, you can add as many advocates and send as many emails as you want to ensure the success of your referral program."
            }
          ]
        },
        {
          storeLogo: [shopifyLogo],
          name: "Growave",
          title: "90 day free trial",
          subtitle:
            "Growave is the all-in-one marketing platform to help you reach their audience, engage users and increase conversions with ease",
          img: socialShopWaveLogo,
          link:
            "https://www.socialshopwave.com/?discount_code=90days4spocketusers",
          headine:
            "Growave is the all-in-one marketing platform to help you reach their audience, engage users and increase conversions with ease",
          benefits: [
            {
              title:
                "An entire ecosystem with all the most needed in eCommerce features",
              text:
                "Feel like it's time to expand your brand? SocialShopWave is an all-in-one app to help you convert visits, reviews, wishlists, interests, and data into sales. Get 90 days of free trial."
            },
            {
              title: "",
              text:
                "Save your time and money by getting the most necessary tools everything you need for your e-commerce business from one place. 10+ features complement each other in an ideal way, combining the solutions for the lack of social proof, the absence of repeated purchases, and customers' engagement."
            },
            {
              title: "",
              text:
                "Build a strong social proof around your site and gain customers’ trust. Increase customer engagement by rewarding customers with loyalty points and launch your own referral program. Boost social sharing and drive new traffic to your store."
            }
          ]
        },
        {
          storeLogo: [woocommerceLogo],
          name: "Beeketing",
          title: "15% off for Beeketing plugins",
          subtitle: "Plugins by Beeketing for WordPress - 5-in-1",
          img: beeketingLogo,
          link: "https://beeketing.com/",
          coupon: "BEESPOCKET",
          headine:
            "Growave is the all-in-one marketing platform to help you reach their audience, engage users and increase conversions with ease",
          benefits: [
            {
              title: "Convert visitors into adding items to cart:",
              text:
                "Recent order notifications popup,Sales countdown clock,Social proof,Coupon popup"
            },
            {
              title: "Upsell & Cross-sell related products",
              text:
                "Manual and auto, Best sellers, Bundles, Sales gamification, Checkout upsells"
            },
            {
              title:
                "Offer a cart-level discount, free-shipping, or free gift, if customers complete order",
              text: "Countdown timer, Exit offer, Recover abandoned carts"
            }
          ]
        },
        {
          storeLogo: [shopifyLogo],
          name: "BoldCommerce",
          title: "10% off Discounts - The Sale App",
          subtitle:
            "The easiest way to run a sale - such as daily deals and storewide sales - with a single click; no coupon codes required.",
          img: boldCommerceLogo,
          link: "https://promo.boldcommerce.com/spocket",
          headine:
            "The easiest way to run a sale - such as daily deals and storewide sales - with a single click; no coupon codes required.",
          benefits: [
            {
              title: "Storewide sales with a click",
              text:
                "The easiest way to run a sale on your store. Set your discount, apply it to products, collections, or your entire store with a click!"
            },
            {
              title: "Daily Deals & Flash Sales",
              text:
                "Use the countdown sale timer to create urgency. On each product show a live countdown timer with the exact time left on the flash sale."
            },
            {
              title: "Black Friday & Cyber Monday",
              text:
                "Create a collection called Black Friday Sale & use our auto-tagging feature to tag products on discount automatically into the collection"
            }
          ]
        },
        {
          storeLogo: [shopifyLogo],
          name: "BoldCommerce",
          title: "10% off Loyalty Points and Rewards",
          subtitle:
            "Increase repeat purchases and encourage your customers to buy more by offering a simple, easy-to-use rewards program",
          img: boldCommerceLogo,
          link: "https://promo.boldcommerce.com/spocket",
          headine:
            "Increase repeat purchases and encourage your customers to buy more by offering a simple, easy-to-use rewards program",
          benefits: [
            {
              title: "Customer loyalty",
              text:
                "Create a loyalty program that motivates customers to spend more to reach rewards, and then shop again to use them."
            },
            {
              title: "Referral program",
              text:
                "Turn your customers into advocates by rewarding them for bringing you new business and incentivizing new customers to start buying from you."
            },
            {
              title: "Seamless experience",
              text:
                "Give members full access to your program with a customizable widget that also showcases your rewards to every visitor."
            }
          ]
        },
        {
          storeLogo: [shopifyLogo],
          name: "BoldCommerce",
          title: "10% off Memberships",
          subtitle:
            "Offer your members access to special pricing, exclusive products, and content.",
          img: boldCommerceLogo,
          link: "https://promo.boldcommerce.com/spocket",
          headine:
            "Offer your members access to special pricing, exclusive products, and content.",
          benefits: [
            {
              title: "Show or hide Member content",
              text:
                "Show or hide any piece of content, products, page, prices, add-to-cart buttons, menu items and more! Even swap liquid templates for members."
            },
            {
              title: "Sell memberships",
              text:
                "BUILT IN recurring payments so you can charge for your memberships if you like."
            },
            {
              title: "Unlimited Member Tiers",
              text:
                "Create member tiers and give your BEST customers exclusive access to new products, blogs, and content."
            }
          ]
        }
      ]
    },
    conversion: {
      header: {
        title: "Sales and Conversion Apps",
        subtitle: "Increase your conversion rate and turn traffic into sales",
        img: targetIcon
      },
      apps: [
        {
          storeLogo: [shopifyLogo, woocommerceLogo],
          name: "Yuspify",
          title: "20% off forever",
          subtitle:
            "Automate your personalized and related product recommendations",
          img: yuspifyLogo,
          link: "https://apps.shopify.com/yuspify-personalization-engine",
          coupon: "SPOCKET20",
          headine: "20% off from AI-Powered Product Recommendations by Yuspify",
          benefits: [
            {
              title: "Help your customers find relevant products",
              text:
                "Increase eCommerce revenues up to 15%, start free for 30-days on Shopify and WooCommerce."
            }
          ]
        },
        {
          storeLogo: [shopifyLogo],
          name: "Loox",
          title: "20% off an Advanced Plan",
          subtitle:
            "Collect product reviews with photos & boost sales with reviews",
          img: looxLogo,
          link: "http://loox.io/app/spocket",
          headine: "20% off an Advanced Plan for Loox reviews",
          benefits: [
            {
              title: "Get reviews on autopilot",
              text:
                "Collect tons of reviews from happy customers and offer discounts in exchange for reviews with photos"
            },
            {
              title: "Build trust",
              text:
                "Display reviews in stunning widgets that seamlessly integrate into your store"
            },
            {
              title: "Boost conversion rates",
              text:
                "Build credibility, trust and grow sales with strong social proof"
            }
          ]
        },
        {
          storeLogo: [shopifyLogo],
          name: "Rise.ai",
          title: "25% Off all plans",
          subtitle: "Get 25% off for all Rise.ai plans",
          img: giftWizardLogo,
          link: "https://apps.shopify.com/rise-ai?utm_source=Spocket_Dashboard",
          headine: "Get 25% off for all Rise.ai plans",
          benefits: [
            {
              title: "Automated Rewards and Loyalty Programs",
              text:
                " Use our WorkFlow, the first automated Rewards and Store Credit program. Incentivize retention & increase loyalty using rules you set up"
            },
            {
              title: "Gift Cards on Every Plan",
              text:
                "Enable customers to send branded Gift Cards & Store Credit directly to recipients, attach animated greeting cards and schedule Gift Cards"
            },
            {
              title: "Bulk Create Store Credit Codes ",
              text:
                "Create bulk codes and store credit to use on marketing, retention & loyalty campaigns and physical cards."
            }
          ]
        },
        {
          storeLogo: [shopifyLogo],
          name: "BoldCommerce",
          title: "10% off Custom Pricing",
          subtitle:
            "Automatically assign customers to new pricing tiers when specific milestones are met and offer wholesale/tiered pricing",
          img: boldCommerceLogo,
          link: "https://promo.boldcommerce.com/spocket",
          headine:
            "Automatically assign customers to new pricing tiers when specific milestones are met and offer wholesale/tiered pricing",
          benefits: [
            {
              title: "Custom Pricing Levels",
              text:
                "Offer multiple wholesale pricing and tiered pricing on your products. Set automated rules, or simply tag customers wholesale, and that's it!"
            },
            {
              title: "Wholesale & VIP automation",
              text:
                "Multiple levels of wholesale B2B pricing? Use our auto-tagging feature to automatically move dealers up wholesale levels as they spend more."
            },
            {
              title: "Wholesale Power Features",
              text:
                "Use pricing rules, upload wholesale prices by spreadsheet, or use the detailed grid to assign each product's wholesale price & bulk discount"
            }
          ]
        },
        {
          storeLogo: [shopifyLogo],
          name: "BoldCommerce",
          title: "10% off Product Bundles",
          subtitle:
            "Sell more products by creating unique bundle sales and BOGO offers",
          img: boldCommerceLogo,
          link: "https://promo.boldcommerce.com/spocket",
          headine:
            "Sell more products by creating unique bundle sales and BOGO offers",
          benefits: [
            {
              title: "Bundle to Increase Sales",
              text:
                "Offering product bundles drastically increases average order value! Sell more by offering discounts on them when purchased as a bundle"
            },
            {
              title: "Promote Bundle Offers",
              text:
                "Bold Bundles automatically promotes your bundle offers on the storefront, and lets customers know how much they'll save by buying the set."
            },
            {
              title: "Flexible Bundle Discounts",
              text:
                "You can bundle either a few specific products, or choose an entire collection so that customers can mix and match to qualify for a discount."
            }
          ]
        },
        {
          storeLogo: [shopifyLogo],
          name: "BoldCommerce",
          title: "10% off Sales Motivator",
          subtitle:
            "Reward your customers with free shipping or a free gift with purchase, displaying targeted messages.",
          img: boldCommerceLogo,
          link: "https://promo.boldcommerce.com/spocket",
          headine:
            "Reward your customers with free shipping or a free gift with purchase, displaying targeted messages.",
          benefits: [
            {
              title: "Interactive Promotions",
              text:
                "Boost sales with interactive promotions that display messages of how much customers need to spend to reach a goal when they add to cart."
            },
            {
              title: "Smart Free Shipping Bar",
              text:
                "Free Shipping when a customer spends $100? Only in certain countries? Our Smart Geo-Fenced motivators ONLY show in countries you offer it."
            },
            {
              title: "Boost Sales Like Never Before!",
              text:
                "Boost sales and increase AOV by 20-30% by letting customers know how close they are to receiving a promotion, a free gift, or free shipping."
            }
          ]
        },
        {
          storeLogo: [shopifyLogo],
          name: "BoldCommerce",
          title: "10% off Upsell Smarter",
          subtitle:
            "Spend less time managing your returns through emails or a ticket system",
          img: boldCommerceLogo,
          link: "https://promo.boldcommerce.com/spocket",
          headine:
            "Spend less time managing your returns through emails or a ticket system. With Bold Returns Manager, customers can submit their returns through a portal that allows them to track the status of their return. The Bold Returns Manager will generate and send UPS shipping labels that customers can print for free at home.",
          benefits: [
            {
              title: "Upsell & Cross-Sell Anywhere",
              text:
                "Make more on every sale by offering upsell & cross-sell products. Upsell on the product page, the cart page, even AFTER CHECKOUT!"
            },
            {
              title: "Upsell & Cross-Sell FUNNELS",
              text:
                "Create a series of follow-up offers that change based on whether the last one was accepted or declined. Got turned down at first? Try again!"
            },
            {
              title: "Make More Money",
              text:
                "It's the ultimate way to create special offers on your store. Join tens of thousands merchants making more money on upsells order today!"
            }
          ]
        }
      ]
    },
    design: {
      header: {
        title: "Store Design Apps",
        subtitle: "Give your store a professional look and feel",
        img: paletteIcon
      },
      apps: [
        {
          storeLogo: [shopifyLogo, woocommerceLogo],
          name: "Pixc",
          title: "20% off first order",
          subtitle:
            "Increase your sales conversions with professionally edited product images",
          img: pixcLogo,
          coupon: "20SPOCKET",
          link: "https://pixc.com/",
          headine:
            "Increase your sales conversions with professionally edited product images, get 20% off your first order!",
          benefits: [
            {
              title:
                "Improve the user experience and increase your sales conversions with professional product images",
              text:
                "Fast delivery. Get professionally edited product photos within 24 hours. Pixc does the work FOR YOU so you can save time and focus on doing what you love in your business."
            }
          ]
        },
        {
          storeLogo: [shopifyLogo],
          name: "Shogun Page Builder",
          title: "20% off",
          subtitle:
            "Customize your store with our easy drag and drop page builder",
          img: shogunPageBuilderLogo,
          link: "https://getshogun.com/d/spocket20",
          headine: "Build, measure, and optimize pages faster with Shogun",
          benefits: [
            {
              title: "Easy to use page builder",
              text:
                "Customize your landing pages, blog pages, product pages, FAQ, slider and tabs with our easy to use drag and drop builder. No coding required"
            },
            {
              title: "Landing page & Blog templates",
              text:
                "Increase sales with our library of 30+ professionally designed landing page, blog page, product page templates, countdown timers and slider"
            },
            {
              title: " Product pages that convert ",
              text:
                "Our product pages and blog editor are optimized for conversion and produce ultra clean code"
            }
          ]
        },
        {
          storeLogo: [shopifyLogo],
          name: "Shoptimized",
          title: "10% off",
          subtitle:
            "Save 10% on The #1 unofficial, high converting Shopify theme",
          img: shoptimizedLogo,
          link: "https://shoptimized.net/",
          coupon: "SPOCKET",
          headine: "Save 10% on The #1 Unofficial Shopify Theme",
          benefits: [
            {
              title:
                "Save up to $2,011 a year on app subscriptions you'll no longer need. ",
              text:
                "Skyrocket your sales with 30+ conversion boosting features. Lightning-Fast load times"
            }
          ]
        },
        {
          storeLogo: [shopifyLogo, woocommerceLogo],
          name: "Wishpond",
          title: "30% off",
          subtitle:
            "Generate leads using Wishpond's social contest campaigns, landing pages, and popups.",
          img: wishpoondLogo,
          link: "https://shoptimized.net/",
          coupon: "SPOCKET",
          headine: "30% Off Wishpond's Basic Plan For Life",
          benefits: [
            {
              title:
                "Generate leads using Wishpond's social contest campaigns, landing pages, and popups.",
              text:
                "Use Wishpond's powerful marketing automation platform to send targeted emails to turn leads into customers."
            },
            {
              title: "",
              text: "Keep your site running fast and smooth"
            }
          ]
        },
        {
          storeLogo: [shopifyLogo],
          name: "ReConvert",
          title: "20% off",
          subtitle: "20% off ReConvert's Thank-You Page Builder",
          img: reConvertLogo,
          link:
            "https://www.stilyoapps.com/reconvert?app_discount=7QhQ5FB9z2vVKxkgEnvCNABeMCyPnRQKwSuxN",
          headine: "20% off ReConvert's Thank-You Page Builder",
          benefits: [
            {
              title: "Upsell & drive extra revenue",
              text:
                "Get an instant revenue boost with our thank you pages- collect customer birthdays, conduct surveys, product upsells, track orders & pop ups"
            },
            {
              title: "Simple & fully customizable",
              text:
                "Easily design your order status page- no technical knowledge necessary! Customize your thank you page with a simple drag and drop interface"
            },
            {
              title: "Retain customers & Upsell",
              text:
                "Get important info using surveys & get customers birthdays. Grow your store's lists - collect SMS, Messenger ,push & upsell post purchase."
            }
          ]
        },
        {
          storeLogo: [shopifyLogo],
          name: "Outlane",
          title: "60% Off",
          subtitle:
            "An ultimate pack of useful resources that will help you launch a successful ecommerce store.",
          img: outlaneLogo,
          link: "https://outlane.co/shopify-starter-pack/",
          headine:
            "An ultimate pack of useful resources that will help you launch a successful ecommerce store.",
          benefits: [
            {
              title: "Stunning Shopify Theme",
              text:
                "The pack includes our stunning Star theme that lets you setup a professional-looking online store in minutes. You can completely customise the appearance of the theme by adjusting colors, typography and setting up theme sections. "
            },
            {
              title: "Design Resources",
              text:
                "Use our Social Media templates, hand-crafted illustrations and branding kit to make your brand look elegant. All the elements are designed to fit any kind of ecommerce business, you can use Shopify Starter Pack to kick start an online store of any complexity!"
            },
            {
              title: "Store Launch Checklist",
              text:
                "We’ve gathered a list of the key tasks that you have to do when launching a new Shopify store. This list helps you make sure that you are ready to launch a store and start making sales."
            }
          ]
        },
        {
          storeLogo: [shopifyLogo],
          name: "BoldCommerce",
          title: "10% off Product Builder",
          subtitle:
            "Create completely unique products step-by-step with full control over the finished product.",
          img: boldCommerceLogo,
          link: "https://promo.boldcommerce.com/spocket",
          headine:
            "Create completely unique products step-by-step with full control over the finished product.",
          benefits: [
            {
              title: "100% customizable products",
              text:
                "Customers can create their own products from scratch based on options you provide, or they can customize existing products on your store."
            },
            {
              title: "Change the image as it's built",
              text:
                "As customers make their selections, the product image will change based on their choices so they can see exactly what they're buying."
            },
            {
              title: "Set conditional logic",
              text:
                "Conditions can apply to entire steps, or just the options within a step. Ex. Selections for Step 2 are based on what was chosen in Step 1."
            }
          ]
        },
        {
          storeLogo: [shopifyLogo],
          name: "BoldCommerce",
          title: "10% off Product Options",
          subtitle:
            "Give your customers exactly what they want, letting them personalize their purchases.",
          img: boldCommerceLogo,
          link: "https://promo.boldcommerce.com/spocket",
          headine:
            "Give your customers exactly what they want, letting them personalize their purchases.",
          benefits: [
            {
              title: "Unlimited Options",
              text:
                "Every product option & custom field imaginable! Swatches, file uploads, text areas, date pickers, conditional logic, radio buttons, & more!"
            },
            {
              title: "Option Cross-sells",
              text:
                "Product options can be linked to products! That means you can bundle in smaller items. Add the matching bag? Yes, it adds the bag too."
            },
            {
              title: "Full Customization",
              text:
                "Tooltips, language to design, customize everything on your custom fields. Customers can even edit their options once they add items to cart!"
            }
          ]
        }
      ]
    },
    shopifyExperts: {
      header: {
        title: "Shopify Experts",
        subtitle: "Build and customize your store with an expert",
        img: shopifyExpertsIcon
      },
      apps: [
        {
          storeLogo: [shopifyLogo],
          name: "Shopision",
          title: "20% off first order",
          subtitle: "Grow your Shopify store with Shopision professional.",
          img: shopisionLogo,
          coupon: "SPOCKET",
          link: "https://www.shopision.com/discount/SPOCKET",
          headine:
            "Grow your Shopify store with Shopision professional setup and design services and let a professional team give new skin to your store.",
          benefits: [
            {
              title: "Choose a package",
              text: "Matching services per package."
            },
            {
              title: "One time payment",
              text: "One-click and your service is ordered."
            },
            {
              title: "Get results",
              text: "Receive the complete project quickly."
            }
          ]
        }
      ]
    },
    support: {
      header: {
        title: "Utilities and Support Apps",
        subtitle: "The essential tools you need to run your store smoothly",
        img: plusIcon
      },
      apps: [
        {
          storeLogo: [shopifyLogo],
          name: "Rewind",
          title: "60 days of free backups",
          subtitle: "Automated, secure backups for stores of all sizes",
          img: rewindLogo,
          link: "https://shopify.rewind.io?partner_id=Spocket",
          headine: "Automated, secure backups for stores of all sizes",
          benefits: [
            {
              title: "Daily, automated backups of your store",
              text:
                "You never have to manually run a backup - we take care of it for you. "
            },
            {
              title: "Flexible restores",
              text:
                "Undo any changes, from small mistakes to huge disasters, in minutes"
            },
            {
              title: "Trusted by 6000+ ecommerce brands",
              text: "Including MVMT, GymShark, and FashionNova."
            }
          ]
        },
        {
          storeLogo: [shopifyLogo, woocommerceLogo],
          name: "Reamaze",
          title: "20% lifetime + extended trial",
          subtitle:
            "Customer support helpdesk with live chat, ticketing, and FAQ",
          img: reamazeLogo,
          link: "https://www.reamaze.com/?ref=spocket",
          headine:
            "Get a 1-month extended free trial and a 20% lifetime discount for Re:amaze!",
          benefits: [
            {
              title: "",
              text:
                "Re:amaze is a helpdesk and customer messaging platform designed to help eCommerce merchants support, engage, and convert customers"
            },
            {
              title: "",
              text:
                "Easily integrate your Shopify, BigCommerce, and WooCommerce customer order data into Re:amaze. See order details, customer notes, and offer cancellations, refunds, and much more directly in your support conversations."
            },
            {
              title: "",
              text:
                "Automate your customer service with chatbots, automated messaging, and triggered workflows."
            }
          ]
        },
        {
          storeLogo: [shopifyLogo],
          name: "BoldCommerce",
          title: "10% off Returns Manager",
          subtitle:
            "Track the status of their return, generate and send UPS shipping labels that customers can print for free at home.",
          img: boldCommerceLogo,
          link: "https://promo.boldcommerce.com/spocket",
          headine:
            "Track the status of their return, generate and send UPS shipping labels that customers can print for free at home.",
          benefits: [
            {
              title: "Save time",
              text:
                "Use less effort managing your returns process through emails or a ticket system; let the app keep track of your outstanding requests"
            },
            {
              title: "Help customers",
              text:
                "Shoppers can submit their return requests through an easy-to-use portal that allows them to track the status of their return"
            },
            {
              title: "Make more money",
              text:
                "Use your returns policy as a marketing tool by giving customers more confidence that they're purchasing from a trustworthy seller"
            }
          ]
        }
      ]
    },
    orderShipping: {
      header: {
        title: "Orders and Shipping",
        subtitle: "Simplify your returns process",
        img: orderShipping
      },
      apps: [
        {
          storeLogo: [shopifyLogo],
          name: "BoldCommerce",
          title: "10% off Subscriptions",
          subtitle:
            "Upgrade your subscription business with powerful, flexible, and reliable features that are available right out of the box.",
          img: boldCommerceLogo,
          link: "https://promo.boldcommerce.com/spocket",
          headine:
            "Upgrade your subscription business with powerful, flexible, and reliable features that are available right out of the box.",
          benefits: [
            {
              title: "Seamless Shopify Integration",
              text:
                "Seamlessly integrate recurring payments with your Shopify store, products, cart, checkout, customer accounts, and order flow. It just works!"
            },
            {
              title: "Recurring Payments That Scale",
              text:
                "Recurring billing designed with Shopify Plus & Enterprise in mind. It's limitless subscriptions and when you're ready to scale, so are we."
            },
            {
              title: "Subscriptions Customers Love!",
              text:
                "Give subscribers the flexibility and control they'll love and deserve. Pause, edit, swap, skip, add-to, update... It's their subscription!"
            }
          ]
        }
      ]
    },
    designGraphics: {
      header: {
        title: "Design & Graphics",
        subtitle:
          "Create logos, media, promotional, and email graphics for your eCommerce business",
        img: paletteIcon
      },
      apps: [
        {
          storeLogo: [shopifyLogo, woocommerceLogo],
          name: "Visme",
          title: "20% off",
          subtitle:
            "20% off all business subscriptions forever + exclusive training webinar access",
          img: vismeLogo,
          link: "https://www.visme.co/",
          coupon: "SPOCKET20VIP",
          headine: "20% off all business subscriptions",
          benefits: [
            {
              title:
                "20% off all business subscriptions <b>forever</b> + exclusive training webinar access",
              text: ""
            }
          ]
        }
      ]
    }
  }
};



// WEBPACK FOOTER //
// ./src/newDropshipperApp/pages/spocketDeals/staticData.js